import { render, staticRenderFns } from "./TariffRegionAutoCompletePicker.vue?vue&type=template&id=4f518e2b&"
import script from "./TariffRegionAutoCompletePicker.vue?vue&type=script&lang=ts&"
export * from "./TariffRegionAutoCompletePicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports